import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import cacheService from "../../../services/cache-service";
const Logout = () => {
  cacheService.resetValue();
  window.location.href = `/`;
};

export default Logout;
